import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from 'antd';
import { CopyOutlined } from '@ant-design/icons';
import printJS from 'print-js';
import { http } from 'services/http';
import { UserRole, withRoleGuard } from 'shared/hocs/with-role-guard.tsx';

interface IOrderInvoiceGenerationProps {
  cargoId: number;
}

export const CargoStickerGeneratorComponent: React.FC<IOrderInvoiceGenerationProps> = (props) => {
  const { cargoId } = props;
  const { t } = useTranslation();

  const handleClick = async () => {
    const result = await http.get(`/v1/cargo/${cargoId}/stickers`);
    printJS({ printable: result.data, type: 'pdf', base64: true });
  };

  return (
    <Button icon={<CopyOutlined />} onClick={handleClick}>
      {t('common:sticker')}
    </Button>
  );
};

export const CargoStickerGenerator = withRoleGuard<IOrderInvoiceGenerationProps>(CargoStickerGeneratorComponent, [
  UserRole.admin,
  UserRole.assistant,
  UserRole.storekeeper,
]);
